export const prodConstants = {
    SUI_CLOCK_OBJECT_ID: "0x6",
    SUI_SYSTEM_STATE_ID: "0x5",
    // AlphaFi constants
    ALPHAFI_FIRST_ORACLE_PACKAGE_ID: "0x378b2a104e8bcd7ed0317f5e6a0ec4fd271d4d12e2fe6c99bcd1f12be725cf4f",
    ALPHAFI_LATEST_ORACLE_PACKAGE_ID: "0x39850d8deb783ef11b10487dc8a80a701506b1471ce11cde83124f35ba3da699",
    ALPHAFI_ORACLE_OBJECT_ID: "0xce4ca140eb264bdc5b03f3268eeb013495f04561e38473aadcf654fb0db6b096",
    ALPHAFI_ORACLE_ADMIN_CAP_ID: "0xefa050ffa6a2f5521c37d176a3502c6a026f9b6d27ad2fe54ed329ee5679a283",
    ALPHAFI_FIRST_STDLIB_PACKAGE_ID: "0x4b591bbc246c9fadd28e7ac895e0778fb0e102f1b0d9f441e78d35f0d1ea1fcc",
    ALPHAFI_LATEST_STDLIB_PACKAGE_ID: "0x4b591bbc246c9fadd28e7ac895e0778fb0e102f1b0d9f441e78d35f0d1ea1fcc",
    // AlphaLend constants
    ALPHALEND_FIRST_PACKAGE_ID: "0xd631cd66138909636fc3f73ed75820d0c5b76332d1644608ed1c85ea2b8219b4",
    ALPHALEND_LATEST_PACKAGE_ID: "0x5209a18e1ae6ac994dd5a188a2d8deb17b2bbab29f63a7b5457bdfe040f69f61",
    LENDING_PROTOCOL_ID: "0x01d9cf05d65fa3a9bb7163095139120e3c4e414dfbab153a49779a7d14010b93",
    LENDING_PROTOCOL_CAP_ID: "0x3aa48bc9692e326c6430199db986c353fd2c64f74d789dd378f237b6e9f91c5c",
    LENDING_PROTOCOL_ADMIN_CAP_ID: "0x0d6365dfebda2264944e54b8912c7bae93c05d0cfb324b4170e68678d743e22b",
    POSITION_CAP_TYPE: "0xd631cd66138909636fc3f73ed75820d0c5b76332d1644608ed1c85ea2b8219b4::position::PositionCap",
    POSITION_TABLE_ID: "0x9923cec7b613e58cc3feec1e8651096ad7970c0b4ef28b805c7d97fe58ff91ba",
    MARKETS_TABLE_ID: "0x2326d387ba8bb7d24aa4cfa31f9a1e58bf9234b097574afb06c5dfb267df4c2e",
    ACTIVE_MARKETS: [1, 3], // to-do: think of a way to store this outside sdk(db or seperate contract)
    // Pyth Constants
    PYTH_PACKAGE_ID: "0x04e20ddf36af412a4096f9014f4a565af9e812db9a05cc40254846cf6ed0ad91",
    PYTH_STATE_ID: "0x1f9310238ee9298fb703c3419030b35b22bb1cc37113e3bb5007c99aec79e5b8",
    WORMHOLE_PACKAGE_ID: "0x5306f64e312b581766351c07af79c72fcb1cd25147157fdc2f8ad76de9a3fb6a",
    WORMHOLE_STATE_ID: "0xaeab97f96cf9877fee2883315d459552b2b921edc16d7ceac6eab944dd88919c",
    PYTH_PRICE_INDENTIFIER_TYPE: "0x04e20ddf36af412a4096f9014f4a565af9e812db9a05cc40254846cf6ed0ad91::price_identifier::PriceIdentifier",
    PYTH_MAINNET_API_ENDPOINT: "https://hermes.pyth.network",
    PYTH_PRICE_PATH: "/api/latest_price_feeds",
    // Coin Types
    SUI_COIN_TYPE: "0x2::sui::SUI",
    USDT_COIN_TYPE: "0xc060006111016b8a020ad5b33834984a437aaa7d3c74c18e09a95d48aceab08c::coin::COIN",
    USDC_COIN_TYPE: "0xdba34672e30cb065b1f93e3ab55318768fd6fef66c15942c9f7cb846e2f900e7::usdc::USDC",
    WUSDC_COIN_TYPE: "0x5d4b302506645c37ff133b98c4b50a5ae14841659738d6d733d59d0d217a93bf::coin::COIN",
    VSUI_COIN_TYPE: "0x549e8b69270defbfafd4f94e17ec44cdbdd99820b33bda2278dea3b9a32d3f55::cert::CERT",
    STSUI_COIN_TYPE: "0xd1b72982e40348d069bb1ff701e634c117bb5f741f44dff91e472d3b01461e55::stsui::STSUI",
    ALPHA_COIN_TYPE: "0xfe3afec26c59e874f3c1d60b8203cb3852d2bb2aa415df9548b8d688e6683f93::alpha::ALPHA",
    SUI_COIN_TYPE_LONG: "0x0000000000000000000000000000000000000000000000000000000000000002::sui::SUI",
};
//# sourceMappingURL=prodConstants.js.map